import { Modal } from 'antd';
import moment from 'moment';
import React from 'react';
import arrowCircleRightFilled from '../../../../assets/img/arrow_circle_right_filled.png';
import './FailedMCQ.modal.css';

const FailedMCQ = props => {
  const { visible, item, test } = props;
  let position,
    centered = null;
  if (item) {
    const itemPos = item.getBoundingClientRect();
    const left = itemPos.right + 10;
    const top = itemPos.top;
    position = { top: `${top}px`, left: `${left}px` };
    const clientWidth = window.innerWidth;
    if (left + 500 > clientWidth) {
      position = null;
      centered = true;
    }
  }

  let retakeText = '90 days';
  if (test) {
    const ninetyDays = moment(test.submit_time).add(3, 'months');
    const daysDiff = moment(ninetyDays).diff(moment(), 'days');
    retakeText = `${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}`;
  }
  
  return (
    <Modal
      wrapClassName={`failedMcqModal ${
        centered ? 'failedMcqModal-centered' : ''
      }`}
      centered={centered}
      style={position}
      visible={visible}
      mask={false}
      maskClosable
      closable
      keyboard
      onCancel={props.onCancel}
    >
      <div className="helpWrapper">
        <h4 className="helpTitle">Don't worry!</h4>
        <h4 className="helpSubTitle">
          Here’s what you can do if you didn’t pass this Quiz:
        </h4>
        <span className="helpTipWrapper">
          <img src={arrowCircleRightFilled} />
          <p className="helpTip">
            <a
              onClick={e => {
                e.preventDefault();
                props.onCancel();
                props.editSkills();
              }}
            >
              Update your {props.use_onboarding_improved_ui_ux_multi_variant === 'v1' ? 'Tech Stacks' : 'Skills'}{' '}
            </a>{' '}
            to pick one that better fits your skills.
          </p>
        </span>
        <span className="helpTipWrapper">
          <img src={arrowCircleRightFilled} />
          <p className="helpTip">
            If you think something’s wrong, you can contact{' '}
            <a href="mailto:support@turing.com"> Turing Support</a>.
          </p>
        </span>
        <span className="helpTipWrapper">
          <img src={arrowCircleRightFilled} />
          <p className="helpTip">
            {' '}
            Wait {retakeText} to take this Quiz again.
          </p>
        </span>
      </div>
    </Modal>
  );
};

export default FailedMCQ;
